import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';

import { WriteKtvAmplifierPassiveNode, WriteOpNode, WriteOpPassiveNode } from '../../../WriteData/WriteHighwayCommunications';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { loadingKtvAmplifierDataComponent, loadingOpDataComponent } from '../../../LoadingData/LoadingDataComponents';


const KtvEditingDialogPassiveNode = ({ open, onClose, cantonRefresh, nodeId, user}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  const [ktvAmplifierData, setKtvAmplifierData] = useState([]);
  const [oPData, setOpData] = useState([]);
  const [selectedOp, setSelectedOp] = useState(null);
  const [selectedAmplifierData, setSelectedAmplifierData] = useState(null);
  const [isVisibleAmplifier, setIsVisibleAmplifier] = useState(false);
  const [isVisibleOp, setIsVisibleOp] = useState(false);

   //загрузка KtvAmplifier
   useEffect(() => {
    const fetchKtvAmplifierData = async () => {
      try {
        const data = await loadingKtvAmplifierDataComponent();
        setKtvAmplifierData(data);
      } catch (error) {
       // console.error("Error in fetchFobData:", error);
      }
    };
    fetchKtvAmplifierData(); 
  }, []); 

   //загрузка OP
     useEffect(() => {
      const fetchOpData = async () => {
        try {
          const data = await loadingOpDataComponent();
          setOpData(data);
        } catch (error) {
         // console.error("Error in fetchFobData:", error);
        }
      };
      fetchOpData(); 
    }, []); 

  const handleChangeAmplifierData = (event) => {
    const selectedAmplifierData = event.target.value;
    setSelectedAmplifierData(selectedAmplifierData);
  };
  
 

  const handleChangeOp = (event) => {
    const selectedOp = event.target.value;
    setSelectedOp(selectedOp);
  };
  
  
  
  async function amplifierDataSave(event) {
     WriteKtvAmplifierPassiveNode(event, selectedAmplifierData, cantonRefresh,setSelectedAmplifierData,  nodeId, user, showSnackbar);
     handleCloseModal();
  }

  async function oPSave(event) {
     WriteOpPassiveNode(event, selectedOp, cantonRefresh,setSelectedOp,  nodeId, user, showSnackbar);
     handleCloseModal();
  }


  function toggleVisibilityAmplifier() {
    setIsVisibleAmplifier(!isVisibleAmplifier);
  }

  function toggleVisibilityOp() {
    setIsVisibleOp(!isVisibleOp);
  }

  const handleCloseModal = () => {
    cantonRefresh();
    setSelectedOp(null);
    setSelectedAmplifierData(null);
    setIsVisibleAmplifier(false);
    setIsVisibleOp(false);
    onClose();
  };

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
        <>
      <div>
      <button onClick={toggleVisibilityAmplifier} className={isVisibleAmplifier ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleAmplifier ? 'КТВ усилитель: скрыть' : 'КТВ усилитель: показать'}
    </button>
        {isVisibleAmplifier && (    
      <div className='divСommunicationsDrawer'>
       
       <img src='./amplifier.png' width='30' height='30' style={{ marginRight: "5px" }} />
      
      <label className='textTitleDrawer'>КТВ усилитель</label>
      <hr className="horizontalLineDrawer" />
      <div>
       <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px", marginInlineEnd:"10px" }} onChange={handleChangeAmplifierData} value={selectedAmplifierData}>
          <option value="null">Выберите усилител</option>
          {ktvAmplifierData.map(ktv => (
            <option key={ktv.id} value={ktv.id}>{ktv.model}</option>
          ))}
        </select>
       

      </div>
      <div >

      
        <button onClick={amplifierDataSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
      </div>
    </div>
        )}
    </div>



    <div>
      <button onClick={toggleVisibilityOp} className={isVisibleOp ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleOp ? 'ОП: скрыть' : 'ОП: показать'}
     </button>
        {isVisibleOp && (    
      <div className='divСommunicationsDrawer'>
      <img src='./op.png' width='30' height='30' style={{ marginRight: "5px" }} />
       <label className='textTitleDrawer' style={{marginInlineEnd: "10px"}}>Оптический приемник</label>
       <hr className="horizontalLineDrawer" />
       <div>
        <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeOp} value={selectedOp}>
           <option value="null">ОП</option>
           {oPData.map(op => (
             <option key={op.id} value={op.id}>{op.model}</option>
           ))}
         </select>
         <br/>
        

        

       </div>
       <div >

       

         <button onClick={oPSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
       </div>
     </div>
        )}
    </div>
        </>

    
      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

        

       {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      /> 

     
    </Dialog>

    
  );
}

export default KtvEditingDialogPassiveNode;